
import Img, { ImgProps } from 'react-cool-img';

const ImpermaxImage = (props: Props): JSX.Element => (
  <Img {...props} />
);

export type Props = ImgProps;

export default ImpermaxImage;
